import env from 'misc/env'

/**
 * We're lazy-evaling because we're loading Stripe asynchronously.
 */
export function checkout (opts) {
  return window.StripeCheckout.configure({
    ...opts,
    key: env.STRIPE_PK,
    image: require('assets/img/taxfyle-icon-256px.png'),
    locale: 'auto',
    billingAddress: true,
    zipCode: true
  })
}



// WEBPACK FOOTER //
// ./src/client/utils/stripe.js